import classNames from 'classnames'
import React from 'react'
import { useTheme } from '@opallabs/hooks'
import * as styles from './styles'
import type { LinkProps } from './types'

export type { LinkProps }

/**
 * Part of our Backbone codebase doesn’t want us to use a link.
 * @see `packages/monolith/app/assets/javascripts/backbone/click_intercept.js.coffee`
 */
const PREVENT_BACKBONE_LINK_INTERCEPTION = 'custom_handler'

/**
 * @note You can implement ‘frame-breaking’ with `target="_top"`.
 */
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (props: LinkProps, ref) => {
    const {
      children,
      className,
      download,
      href,
      onClick,
      onKeyDown,
      rel,
      styleOverrides,
      tabIndex,
      target,
      theme: propTheme,
    } = props
    const providedTheme = useTheme()
    const theme = propTheme ?? providedTheme
    return (
      <a
        className={classNames(
          PREVENT_BACKBONE_LINK_INTERCEPTION,
          // @hack override global styles
          'styled',
          className
        )}
        css={[styles.link({ theme }), styleOverrides]}
        download={download}
        href={href}
        onClick={onClick}
        onKeyDown={onKeyDown}
        ref={ref}
        rel={rel}
        tabIndex={tabIndex}
        target={target}
      >
        {children}
      </a>
    )
  }
)
Link.displayName = 'Lapidary: Link'
